import styled from "styled-components";
import { flexColumn, flexRow } from "./styles";

export const Hero = styled.section``;
export const Container = styled.div`
  width: 100%;
  background: #fff;
  color: #003e21;

  ${flexColumn};
  font-family: "Poppins", sans-serif;
  section {
    position: relative;
    z-index: 5;
  }
  .logo {
    width: 435.16px;
    height: 81.45px;
  }
  .u {
    position: absolute;
    width: 436px;
    height: 407.15px;
    z-index: -1;
    right: 0;
    bottom: 10%;
  }
  h2 {
    font-size: 37.2329px;
    line-height: 50px;
  }
  h1 {
    font-size: 49.6439px;
    text-transform: uppercase;
  }
  h1,
  h2 {
    font-weight: 700;
    font-family: "Poppins", sans-serif;
  }
  .margin-con {
    width: 837.74px;
    padding-top: 78px;
    position: relative;

    .top {
      ${flexRow};
      height: 81.45px;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 39px;
      position: relative;

      .icon-hol {
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(16px);
        border-radius: 96px;
        position: fixed;
        top: 78px;
        margin: auto;
        transform: translateX(800%);
        z-index: 1000;
        ${flexRow};
        width: 80px;
        height: 80px;
        .icon {
          width: 31.15px;
          height: 30.37px;
        }
      }
    }
  }
`;

export const Ad = styled.section`
  display: flex;
  justify-content: space-between;
  width: 100%;
  .ad {
    width: 553px;
  }
  .u {
    right: 0;
    bottom: 10%;
  }
  .title {
    width: 242.79px;
    h2 {
      text-transform: uppercase;
      margin-bottom: 22px;
    }
    .ass {
      width: 242.79px;
      height: 315px;
    }
  }
`;

export const Note = styled.section`
  padding: 102px 38px;
  height: 837.74px;
  h1 {
    margin-bottom: 24px;
  }
  p,
  ul {
    width: 532.9px;
    font-weight: 400;
    font-size: 23.2706px;
    line-height: 37px;
    letter-spacing: 0.01em;
  }
  p,
  li {
    margin-bottom: 38px;
  }
  .persona {
    width: 702.77px;
    height: 363.8px;
    margin-top: 6.71px;
    margin-bottom: 72.14px;
  }
  span {
    opacity: 0.48;
  }
  .text {
    p {
      width: 100%;
      font-size: 18.6165px;
      line-height: 29px;
    }
  }
`;
export const FlexCenter = styled.div`
  display: flex;
  gap: 40.34px;
  img {
    width: 225.72px;
    height: 488.52px;
  }
  h3 {
    font-size: 18.6165px;
    letter-spacing: 0.01em;
    font-weight: 600;
  }
  p {
    font-weight: 400;
    font-size: 10.8596px;
    line-height: 17px;
    letter-spacing: 0.01em;
    width: 227.28px;
  }
  .des-text {
    ${flexColumn};
    min-height: 286px;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const Footers = styled.footer`
  min-height: 100vh;
  position: relative;
  padding: 0 38px;
  margin-top: 37px;

  .logo {
    width: 224.17px;
    height: 41.89px;
    position: absolute;
    top: -10%;
    //  transform: translateX(300%);
    right: 6%;
    margin: auto;
  }
  .rec {
    width: 813.12px;
    height: 726px;
    position: absolute;
    right: -16%;
  }
  h1 {
    margin-top: 93.4px;
  }
  .overlay {
    width: 300px;
    margin-left: 158px;
    margin-top: 46.54px;
    p {
      font-weight: 600;
      font-size: 18.6165px;
      line-height: 157%;
      margin-bottom: 37px;
    }
    .s {
      width: 93.2%;
    }
  }
`;
